module.exports = __webpack_public_path__ + "frontend/images/benefits/apple-pay.gif?12219f4e3a6ad78209edd80414e9caa7";